/* ============================================================================
   טיפול בתמונות בצד הדפדפן.

   כל צילום נדחס לפני שהוא עוזב את המכשיר: תמונה מטלפון היא 3–8 מגה, והיא
   נשלחת פעמיים — פעם ל-Spaces ופעם למודל בתור base64 (שמנפח אותה בעוד שליש).
   1100 פיקסלים ואיכות 0.7 מספיקים בהחלט כדי לקרוא ספרות של מונה.
   ============================================================================ */

export const readFile = (file) =>
  new Promise((res, rej) => {
    const r = new FileReader();
    r.onload = () => res(r.result);
    r.onerror = rej;
    r.readAsDataURL(file);
  });

export const compressImage = (dataUrl, max = 1200, q = 0.62) =>
  new Promise((res) => {
    // PDF וקבצים שאינם תמונה עוברים כמו שהם.
    if (!String(dataUrl).startsWith("data:image")) return res(dataUrl);
    const img = new window.Image();
    img.onload = () => {
      const s = Math.min(1, max / Math.max(img.width, img.height));
      const c = document.createElement("canvas");
      c.width = Math.round(img.width * s);
      c.height = Math.round(img.height * s);
      c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
      res(c.toDataURL("image/jpeg", q));
    };
    img.onerror = () => res(dataUrl);
    img.src = dataUrl;
  });

/** גודל משוער בבתים של data URL — לבדיקת תקרה לפני שליחה. */
export const dataUrlBytes = (dataUrl) => {
  const i = String(dataUrl).indexOf(",");
  return i < 0 ? 0 : Math.floor(((dataUrl.length - i - 1) * 3) / 4);
};

/** התקרה שהשרת אוכף על תמונה למודל (5MB). */
export const MAX_IMAGE_BYTES = 5 * 1024 * 1024;

/**
 * דוחס עד שהתמונה נכנסת לתקרה. צילום מונה בטלפון חדש יכול לצאת גדול גם
 * אחרי דחיסה אחת, ואז השרת דוחה אותו עם invalid_body שקשה להסביר לדייר.
 */
export async function compressForUpload(file, { max = 1100, q = 0.7 } = {}) {
  let out = await compressImage(await readFile(file), max, q);
  let scale = max;
  while (dataUrlBytes(out) > MAX_IMAGE_BYTES && scale > 500) {
    scale = Math.round(scale * 0.75);
    out = await compressImage(out, scale, 0.6);
  }
  return out;
}
